export const CADASTRO_ACTION = 'CADASTRAR';
export const EDITAR_ACTION = 'EDITAR';
export const CADASTRADO_COM_SUCESSO = 'Ramo de Atividade cadastrado com sucesso';

